import {useQuery} from '@tanstack/react-query';

import {getUserExtData, getUserExtDataByName} from '../api';
import {QUERY__USER_EXT_DATA, QUERY__USER_EXT_DATA_BY_NAME} from '../queryKeys';

export const useGetUserExtData = (userId: string) =>
  useQuery({
    queryKey: [QUERY__USER_EXT_DATA, userId],
    queryFn: () => getUserExtData(userId),
    enabled: !!userId,
  });

export const useGetUserExtDataByName = (userId: string, name: string) =>
  useQuery({
    queryKey: [QUERY__USER_EXT_DATA_BY_NAME, userId, name],
    queryFn: () => getUserExtDataByName(userId, name),
    enabled: !!userId && !!name,
  });
